<script setup lang="ts">
import { inject, ref, Ref } from 'vue';
import { formatDate } from '@/utils/dateUtils';
import Button from 'primevue/button';
import RadioButton from 'primevue/radiobutton';

const dialogRef = inject('dialogRef') as Ref;
const availableDates = dialogRef?.value?.options.data.availableDates;
const isSave = dialogRef?.value?.options.emits.isSave;
const dateSelected = ref('');

const save = (date) => {
  isSave(date);
};
</script>
<template>
  <div class="main">
    <div>
      <div class="header">
        <div class="title font-bold text-lg">
          {{ $t('advance_quote.alternative_date_title') }}
        </div>
        <div class="desc mt-2">
          {{ $t('advance_quote.alternative_date_desc') }}
        </div>
      </div>
      <div class="list_date mt-3">
        <p class="font-bold">{{ $t('advance_quote.next_available_date') }} :</p>
        <div>
          <div class="flex align-items-center gap-2 mt-2" v-for="(date, index) in availableDates" :key="index">
            <RadioButton v-model="dateSelected" name="classSelected" :value="date.date" />
            <div>{{ formatDate(date.date, 'EEEE, MMMM d, yyyy', false) }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="mt-5 text-center">
      <Button id="save-btn" :label="$t('common.buttons.submit')" @click="save(dateSelected)" :disabled="!dateSelected" />
    </div>
  </div>
</template>
